import { signOut } from '@firebase/auth';
import { auth } from '../firebase';

const turnOffMultyUser = () => {
  window.localStorage.removeItem('multyuser');
  signOut(auth);
};

export default turnOffMultyUser;
